<mat-form-field class="flex-half">
    <mat-label>Organisasjonsnummer</mat-label>
    <input matInput
        [disabled]="disabled"
        [errorStateMatcher]="matErrorMatcher"
        [(ngModel)]="value"
        (blur)="onTouched($event)"
        (keyup.enter)="getCompanyInfo()" />

    <button *ngIf="companyInfo === null" matTooltip="Hent info fra Brønnøysundregistrene" mat-icon-button matSuffix disableRipple="true" (click)="getCompanyInfo()" type="button">
        <mat-icon>search</mat-icon>
    </button>

    <button *ngIf="companyInfo !== null" matTooltip="Fjern oppslagsinformasjon om organisasjonsnummer" mat-icon-button matSuffix disableRipple="true" (click)="clearCompanyFormValues()"
        type="button">
        <mat-icon>clear</mat-icon>
    </button>

    <mat-hint>Format: 987654321 (9 siffer)</mat-hint>

    <mat-error *ngIf="!errors?.required && errors?.invalidFormat">
        Ugyldig organisasjonsnummer - {{errors?.invalidFormat.value}}
    </mat-error>

    <mat-error *ngIf="errors?.required">
        Organisasjonsnummer er et obligatorisk felt
    </mat-error>

</mat-form-field>
